export default "__VITE_ASSET__bb145268__"